import { ObjectDirective } from 'vue';
declare const vSizeDirective: ObjectDirective;
export default vSizeDirective;
